module.exports = __webpack_public_path__ + "img/image-fiche-menuiserie-modal.673f0ee8.png";